const URLTB = {
    getBroadcast: {//首页广播  '
		url: '/manager/commission/top20',
		params: {}
	},
    getRankList: {//首页排行榜
		url: '/manager/rank/list',
		params: {}
	},
    getProduct: {//首页产品库
		url: '/front/portal/product/type',
		params: {}
	},
    ProductTypeList: {
		url: '/front/portal/product/findByProductTypeId' //产品列表
	},
    teamRanking: {
		url: '/front/team/ranking' //团队排行榜
	},
    getMessage: {
		url: '/front/message/list' //消息
	},
    messageStatus: {
		url: '/front/message/status' //消息状态 是否已读
	},
    getMineData: {
		url: '/front/mine/general' //个人中心数据
	},
    myScores: {
		url: '/manager/points/list' //我的积分
	},
    getCards: {
		url: '/front/agent/cards' //银行卡查询
	},
    editCards: {
		url: '/front/agent/default' //修改默认银行卡
	},
    agentCash: {
		url: '/front/agent/cash' //积分提现
	},
    getOrder: {
		url: '/front/agent/list' //我的订单
	},
    addOrder: {
		url: '/front/agent/order' //新增订单
	},
    getOrderDetail: {
		url: '/front/agent/order-detail' //我的订单 订单详情
	},
    getOrderProcess: {
		url: '/manager/broker/process' //我的订单 订单过程
	},
    getClientsType: {
		url: '/auth/trace/num' //我的客户 客户类型
	},
    getClients: {
		url: '/auth/trace/clients' //我的客户
	},
    clientsAttention: {
		url: '/auth/trace/attention' //我的客户 修改关注状态
	},
    clientsDetail: {
		url: '/auth/trace/detail' //我的客户 客户详情
	},
    getViews: {
		url: '/auth/trace/visits' //访问量
	},
    changeStatus: {
		url: '/auth/trace/status' //访问量 修改已读未读状态 traceId
	},
    communication: {//get
		url: '/manager/communication/list' //咨询、投诉建议查询列表 userId, type=advice(投诉建议)/consult(咨询)from=front
	},
    communicationDetail: {//get
		url: '/manager/communication/one' //咨询、投诉建议 详情查询 id, type=advice(投诉建议)/consult(咨询)
	},
    addCommunication: {//post
		url: '/manager/communication/one' //添加咨询、投诉建议 id, type=advice(投诉建议)/consult(咨询)
	},
    getLittleShop: {//get
		url: '/auth/staffs/card' //我的小店
	},
}
export default URLTB;